import { jsx as _jsx } from "react/jsx-runtime";
import { createFileRoute } from '@tanstack/react-router';
import { checkOrgPermissions } from '@ui/guards/route-checks';
import { getGetServerAuthTokenQueryOptions } from 'ze-sdk';
export const Route = createFileRoute('/org/$organization/settings/server-tokens/$token')({
    loader: async (param)=>{
        let { params, context } = param;
        var _ref;
        const { organization, token } = params;
        const can = await checkOrgPermissions(context.queryClient, organization);
        const canUpdateOrganizationSettings = (_ref = can === null || can === void 0 ? void 0 : can.updateOrganizationSettings) !== null && _ref !== void 0 ? _ref : false;
        if (canUpdateOrganizationSettings && token) {
            await context.queryClient.ensureQueryData(getGetServerAuthTokenQueryOptions({
                organization,
                tokenName: token
            }));
        }
        return {
            canUpdateOrganizationSettings
        };
    },
    component: RouteComponent
});
function RouteComponent() {
    return /*#__PURE__*/ _jsx("div", {
        children: 'Hello "/org/$organization/settings/server-tokens/$token"!'
    });
}
